import React, { useEffect } from 'react';

export default function CookiePolicy() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://app.termly.io/embed-policy.min.js';
        script.id = 'termly-jssdk';
        document.body.appendChild(script);

        return () => {
            // The Termly SDK can relocate or remove its own script tag, so the
            // node may no longer be a child of document.body by unmount. Guard
            // the removal to avoid a NotFoundError when that happens.
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    return (
        <div>
            <div
                name="termly-embed"
                data-id="5772044a-a348-422e-8f32-7465893245d2"
            />
        </div>
    );
}
